<div class="clug-form-modal" *ngIf="createJobAssignment" [formGroup]="createJobAssignment">
  <div class="clug-form-modal-loader" *ngIf="loading">
    <div class="auth-spinner" aria-label="Loading"></div>
  </div>

  <div class="modal-head">
    <div class="title-block">
      <h2>Add Assignment</h2>
      <span class="sub">Connect a candidate to a job, choose approvers and the work period.</span>
    </div>
    <button type="button" class="close-btn" title="Close" (click)="onClose()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body tight">
    <div class="form-section">
      <div class="form-section-head">
        <span class="title">
          <span class="ico"><i class="bi bi-layout-text-window-reverse"></i></span>Assignment
        </span>
        <span class="req-pill">Required</span>
      </div>

      <div class="grid-2">
        <div class="field tight">
          <label>Job <span class="req">*</span></label>
          <input formControlName="job_uuid" style="display: none;" />
          <app-search-select
            (onChange)="onSearchChange($event)"
            [endpoint]="API_CONSTANT.JOBS"
            [control]="createJobAssignment.controls.job_uuid"
            controlName="job_uuid"
            titleKey="title">
          </app-search-select>
          <span class="hint">Search and pick from open jobs.</span>
        </div>

        <div class="field tight">
          <label>Candidate <span class="req">*</span></label>
          <input formControlName="candidate_uuid" style="display: none;" />
          <app-search-select
            (onChange)="onSearchChange($event)"
            [endpoint]="API_CONSTANT.USERS"
            [control]="createJobAssignment.controls.candidate_uuid"
            controlName="candidate_uuid"
            titleKey="name">
          </app-search-select>
          <span class="hint">Only candidates marked Active appear here.</span>
        </div>

        <div class="field tight full">
          <label>Timesheet approvers <span class="req">*</span></label>
          <div class="chip-input" (click)="focusApproverInput($event)">
            <span class="chip" *ngFor="let uuid of selectedApproverUuids">
              {{ getApproverName(uuid) }}
              <button type="button" title="Remove" (click)="removeApprover(uuid, $event)">
                <i class="bi bi-x"></i>
              </button>
            </span>
            <input
              #approverInput
              type="text"
              [(ngModel)]="approverSearch"
              [ngModelOptions]="{standalone: true}"
              [placeholder]="selectedApproverUuids.length ? '' : 'Add approver…'"
              (focus)="approverDropdownOpen = true"
              (input)="approverDropdownOpen = true"
              (blur)="onApproverBlur()" />

            <div class="chip-dropdown" *ngIf="approverDropdownOpen && filteredApprovers.length">
              <div class="chip-option" *ngFor="let a of filteredApprovers"
                (mousedown)="addApprover(a.uuid, $event)">
                <span class="ic">{{ getApproverInitials(a.name) }}</span>
                <span>{{ a.name }}</span>
              </div>
            </div>
            <div class="chip-dropdown" *ngIf="approverDropdownOpen && !filteredApprovers.length && availableApprovers.length">
              <div class="chip-empty">No matching approvers.</div>
            </div>
          </div>
          <span class="hint" *ngIf="!availableApprovers.length">Pick a job first to see available approvers.</span>
          <span class="hint" *ngIf="availableApprovers.length">Pick from this client's contacts.</span>
        </div>

        <div class="field tight full">
          <label>Period <span class="req">*</span></label>
          <div class="daterange" (click)="picker.open()"
            [class.invalidField]="(createJobAssignment?.controls['start_date']?.errors && createJobAssignment?.controls['start_date']?.touched) || (createJobAssignment?.controls['end_date']?.errors && createJobAssignment?.controls['end_date']?.touched)">
            <i class="bi bi-calendar4"></i>
            <mat-date-range-input [rangePicker]="picker" [min]="minLimit" [max]="maxLimit">
              <input matStartDate formControlName="start_date" placeholder="Start date" />
              <input matEndDate formControlName="end_date" placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle [for]="picker" style="display:none;"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="form-error" *ngIf="error">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="modal-foot">
    <div class="left">
      <i class="bi bi-info-circle"></i>
      <span>Required fields marked <span class="req">*</span>. Save to create the record.</span>
    </div>
    <div class="right">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="loading || !createJobAssignment.valid"
        (click)="onSubmit()">
        <i class="bi bi-check-lg"></i>Save
      </button>
    </div>
  </div>
</div>
